/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { I18n } from "@aws-amplify/core";
import AmplifyConfirmSignIn from "aws-amplify-react/lib/Auth/ConfirmSignIn";
import { AuthShell, withInlineAuthError } from "./AuthFormShared";
import { ConfirmSignInFormView } from "./AuthFormViews";

const ConfirmSignInBase: any = withInlineAuthError(AmplifyConfirmSignIn);

export class ConfirmSignIn extends ConfirmSignInBase {
    showComponent() {
        const { hide } = this.props;
        if (hide && hide.includes(ConfirmSignIn)) {
            return null;
        }

        return (
            <AuthShell title={I18n.get(`Confirm ${this.state.mfaType} Code`)}>
                <ConfirmSignInFormView
                    error={this.state.authError}
                    mfaType={this.state.mfaType}
                    onBackToSignIn={() => this.changeState("signIn")}
                    onFieldChange={this.handleInputChange}
                    onSubmit={this.confirm}
                />
            </AuthShell>
        );
    }
}

export default ConfirmSignIn;
